import { render, staticRenderFns } from "./GoalsPast.vue?vue&type=template&id=40d20557&scoped=true&"
import script from "./GoalsPast.vue?vue&type=script&lang=ts&"
export * from "./GoalsPast.vue?vue&type=script&lang=ts&"
import style0 from "./GoalsPast.vue?vue&type=style&index=0&id=40d20557&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d20557",
  null
  
)

export default component.exports